module.exports = "https://s.pinimg.com/webapp/style/images/PT@2x-6275f2d4.png";